import Cookies from "js-cookie";
import "element-ui/lib/theme-chalk/index.css";

//语言
export const setLang = (state, data) => {
  console.log("语言切换", data);
  state.local = data;
  localStorage.setItem("locale", data);
};

export const addUserInfo = (state, userInfo) => {
  Cookies.set("userInfo", userInfo, {
    expires: 7
  });
  state.userInfo = userInfo;
};

export const quitLogin = state => {
  state.userInfo = {};
  state.user = {};
  state.token = "";
  state.isLogin = false;
  Cookies.remove("user");
  Cookies.remove("userInfo");
  Cookies.remove("token");
};

// 分类树
export const addCategoryTree = (state, data) => {
  console.log("datadata===", data);
  state.CategoryTree = data;
};
//冷冻方式列表
export const addFreezingModeList = (state, data) => {
  state.FreezingModeList = data;
};

// 分类树
export const addArticleCategory = (state, data) => {
  state.articleCategory = data;
};
// 设置分类
export const setCategory = (state, data) => {
  state.category = data;
};
// 设置冷冻分类
export const setFreez = (state, data) => {
  state.freez = data;
};
// 设置竞拍详情
export const setProductDetail = (state, data) => {
  state.productDetail = data;
};
// 设置出价列表
export const setHistoryPrice = (state, data) => {
  state.historyPrice = data;
};
//设置导航第一个菜单的名字
export const modifyNavFirstName = (state, navFirstName) => {
  // console.log('navFirstName===', navFirstName)
  state.navFirstName = navFirstName;
  Cookies.set("navFirstName", navFirstName);
};
export const setUser = (state, data) => {
  state.user = data;
  Cookies.set("user", data);
};



// WEBPACK FOOTER //
// ./src/store/mutations.js